import { Component, Inject, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface IData {
    dialogHeading: string;
}

@Component({
    selector: 'cb-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {

    @Input() public disableCloseButtonFocus = false;
    @Input() public dialogHeading: string;
    @Input() public canClose = true;
    @Input() public showActions = true;
    @Output() public readonly cancelDialog: EventEmitter<any> = new EventEmitter();

    @HostBinding('class.fullscreen') @Input() private fullscreen = false;

    constructor(
        public readonly dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData
    ) {
    }

    public ngOnInit(): void {
        if (!this.dialogHeading) {
            this.dialogHeading = this.data.dialogHeading;
        }
    }

    public cancel(isFromCloseIcon: boolean): void {
        if (!this.canClose) {
            return;
        }
        if (this.cancelDialog.observers.length) {
            this.cancelDialog.emit();
        } else {
            this.dialogRef.close(isFromCloseIcon ? undefined : false);
        }
    }
}
